import { render, staticRenderFns } from "./senha-alterar.vue?vue&type=template&id=056a4d75"
import script from "./senha-alterar.vue?vue&type=script&lang=js"
export * from "./senha-alterar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports